// Import model
import { SectionLine } from '../models/SectionLine';

// Import base class serializer
import { EntityOwnedModelSerializer } from './EntityOwnedModelSerializer';

// Import dependency types (models and enums used in properties)
import { SfSectionLine } from '../models/SfSectionLine';

// Import dependency serializers (for complex types)
import { SfSectionLineSerializer } from './SfSectionLineSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for SectionLine - handles JSON serialization and deserialization with type validation
 */
export class SectionLineSerializer {
  /**
   * Deserializes a JSON string into a SectionLine instance
   */
  static deserialize(json: string): SectionLine {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a SectionLine instance
   */
  static fromObject(obj: any): SectionLine {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to SectionLine');
    }


    const instance: SectionLine = {
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      entityIdName: obj['entityId|Name'] as string | undefined,
      id: obj['_id'] as string | undefined,
      createdDate: obj['createdDate'] as string | undefined,
      externalId: obj['externalId'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      properties: obj['properties'] ? SfSectionLineSerializer.fromObject(obj['properties']) : undefined as any,
      flowId: obj['flowId'] as string | undefined,
      flowIdName: obj['flowId|Name'] as string | undefined,
      objectStatusId: obj['objectStatusId'] as string | undefined,
      objectStatusIdName: obj['objectStatusId|Name'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of SectionLine instances
   */
  static deserializeArray(json: string): SectionLine[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a SectionLine instance to a JSON string
   */
  static serialize(instance: SectionLine): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a SectionLine instance to a plain object
   */
  static toObject(instance: SectionLine): any {
    return {
      'name': instance.name,
      'description': instance.description,
      'entityId': instance.entityId,
      'entityId|Name': instance.entityIdName,
      '_id': instance.id,
      'createdDate': instance.createdDate,
      'externalId': instance.externalId,
      'isActive': instance.isActive,
      'properties': instance.properties ? SfSectionLineSerializer.toObject(instance.properties) : undefined,
      'flowId': instance.flowId,
      'flowId|Name': instance.flowIdName,
      'objectStatusId': instance.objectStatusId,
      'objectStatusId|Name': instance.objectStatusIdName,
    };
  }

  /**
   * Serializes an array of SectionLine instances to a JSON string
   */
  static serializeArray(instances: SectionLine[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
